import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n/i18n';

export enum KitType {
  HOME = 'home',
  AWAY = 'away',
  THIRD = 'third',
  GOALKEEPER = 'goalkeeper',
}

/** Human-readable labels for the kit type picker. */
export const KIT_TYPE_LABELS: Record<KitType, MessageDescriptor> = {
  [KitType.HOME]: msg({ message: 'Домашняя', comment: 'Комплект формы команды' }),
  [KitType.AWAY]: msg({ message: 'Гостевая', comment: 'Комплект формы команды' }),
  [KitType.THIRD]: msg({ message: 'Третья', comment: 'Комплект формы команды' }),
  [KitType.GOALKEEPER]: msg({ message: 'Вратарская', comment: 'Комплект формы команды' }),
};

/** Kit types in the order they are shown in the editor. */
export const ALL_KIT_TYPES: KitType[] = [KitType.HOME, KitType.AWAY, KitType.THIRD, KitType.GOALKEEPER];

/** Проверка сегмента URL: `/teams/:id/kits/:kitType` принимает только эти значения. */
export const isKitType = (value?: string): value is KitType => ALL_KIT_TYPES.includes(value as KitType);
